/* eslint-disable no-loop-func */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Select, { createFilter } from 'react-select';
import moment from 'moment';
import { Button, Card, Col, Row, Spin, Typography, Select as AntSelect, Modal, Checkbox, Switch,Input, Pagination, Tabs } from 'antd';

const { TabPane } = Tabs;
import { setDoctorProfile } from '../../actions/index';
import {
  fetchDoctorPracticeCenters,
  updatePracticeCenter,
  updatePracticeCenterActiveStatus,
  fetchDoctorSlots,
  deleteDoctorSlot,
  persistDoctorSlots,
  updateAppointmentType,
  updateOnCallBasis,
  updateShowSameDaySlotsStatus,
  updateTimeRangeStatus,
  fetchCenters,
} from '../../services';
import styled, { ThemeProvider } from 'styled-components';
import { SemiboldText } from '../../components/common/Text';
import DoctorSlotsBulkAdd from './DoctorSlotsBulkAdd';
const { Title } = Typography;
const { Option } = AntSelect;

// const Row = styled.div`
//   display: flex;
//   flex-direction: row;
// `;

// const Col = styled.div`
//   display: flex;
//   flex: 1;
//   flex-direction: column;
//   margin-right: 10px;
// `;

export const dayOptions = [
  {
    value: '1',
    label: 'Sunday',
  },
  {
    value: '2',
    label: 'Monday',
  },
  {
    value: '3',
    label: 'Tuesday',
  },
  {
    value: '4',
    label: 'Wednesday',
  },
  {
    value: '5',
    label: 'Thursday',
  },
  {
    value: '6',
    label: 'Friday',
  },
  {
    value: '7',
    label: 'Saturday',
  },
];

export const timeSlots = [
  { value: '06:00:00', label: '06:00 AM' },
  { value: '06:05:00', label: '06:05 AM' },
  { value: '06:10:00', label: '06:10 AM' },
  { value: '06:15:00', label: '06:15 AM' },
  { value: '06:20:00', label: '06:20 AM' },
  { value: '06:25:00', label: '06:25 AM' },
  { value: '06:30:00', label: '06:30 AM' },
  { value: '06:35:00', label: '06:35 AM' },
  { value: '06:40:00', label: '06:40 AM' },
  { value: '06:45:00', label: '06:45 AM' },
  { value: '06:50:00', label: '06:50 AM' },
  { value: '06:55:00', label: '06:55 AM' },
  { value: '07:00:00', label: '07:00 AM' },
  { value: '07:05:00', label: '07:05 AM' },
  { value: '07:10:00', label: '07:10 AM' },
  { value: '07:15:00', label: '07:15 AM' },
  { value: '07:20:00', label: '07:20 AM' },
  { value: '07:25:00', label: '07:25 AM' },
  { value: '07:30:00', label: '07:30 AM' },
  { value: '07:35:00', label: '07:35 AM' },
  { value: '07:40:00', label: '07:40 AM' },
  { value: '07:45:00', label: '07:45 AM' },
  { value: '07:50:00', label: '07:50 AM' },
  { value: '07:55:00', label: '07:55 AM' },
  { value: '08:00:00', label: '08:00 AM' },
  { value: '08:05:00', label: '08:05 AM' },
  { value: '08:10:00', label: '08:10 AM' },
  { value: '08:15:00', label: '08:15 AM' },
  { value: '08:20:00', label: '08:20 AM' },
  { value: '08:25:00', label: '08:25 AM' },
  { value: '08:30:00', label: '08:30 AM' },
  { value: '08:35:00', label: '08:35 AM' },
  { value: '08:40:00', label: '08:40 AM' },
  { value: '08:45:00', label: '08:45 AM' },
  { value: '08:50:00', label: '08:50 AM' },
  { value: '08:55:00', label: '08:55 AM' },
  { value: '09:00:00', label: '09:00 AM' },
  { value: '09:05:00', label: '09:05 AM' },
  { value: '09:10:00', label: '09:10 AM' },
  { value: '09:15:00', label: '09:15 AM' },
  { value: '09:20:00', label: '09:20 AM' },
  { value: '09:25:00', label: '09:25 AM' },
  { value: '09:30:00', label: '09:30 AM' },
  { value: '09:35:00', label: '09:35 AM' },
  { value: '09:40:00', label: '09:40 AM' },
  { value: '09:45:00', label: '09:45 AM' },
  { value: '09:50:00', label: '09:50 AM' },
  { value: '09:55:00', label: '09:55 AM' },
  { value: '10:00:00', label: '10:00 AM' },
  { value: '10:05:00', label: '10:05 AM' },
  { value: '10:10:00', label: '10:10 AM' },
  { value: '10:15:00', label: '10:15 AM' },
  { value: '10:20:00', label: '10:20 AM' },
  { value: '10:25:00', label: '10:25 AM' },
  { value: '10:30:00', label: '10:30 AM' },
  { value: '10:35:00', label: '10:35 AM' },
  { value: '10:40:00', label: '10:40 AM' },
  { value: '10:45:00', label: '10:45 AM' },
  { value: '10:50:00', label: '10:50 AM' },
  { value: '10:55:00', label: '10:55 AM' },
  { value: '11:00:00', label: '11:00 AM' },
  { value: '11:05:00', label: '11:05 AM' },
  { value: '11:10:00', label: '11:10 AM' },
  { value: '11:15:00', label: '11:15 AM' },
  { value: '11:20:00', label: '11:20 AM' },
  { value: '11:25:00', label: '11:25 AM' },
  { value: '11:30:00', label: '11:30 AM' },
  { value: '11:35:00', label: '11:35 AM' },
  { value: '11:40:00', label: '11:40 AM' },
  { value: '11:45:00', label: '11:45 AM' },
  { value: '11:50:00', label: '11:50 AM' },
  { value: '11:55:00', label: '11:55 AM' },
  { value: '12:00:00', label: '12:00 PM' },
  { value: '12:05:00', label: '12:05 PM' },
  { value: '12:10:00', label: '12:10 PM' },
  { value: '12:15:00', label: '12:15 PM' },
  { value: '12:20:00', label: '12:20 PM' },
  { value: '12:25:00', label: '12:25 PM' },
  { value: '12:30:00', label: '12:30 PM' },
  { value: '12:35:00', label: '12:35 PM' },
  { value: '12:40:00', label: '12:40 PM' },
  { value: '12:45:00', label: '12:45 PM' },
  { value: '12:50:00', label: '12:50 PM' },
  { value: '12:55:00', label: '12:55 PM' },
  { value: '13:00:00', label: '01:00 PM' },
  { value: '13:05:00', label: '01:05 PM' },
  { value: '13:10:00', label: '01:10 PM' },
  { value: '13:15:00', label: '01:15 PM' },
  { value: '13:20:00', label: '01:20 PM' },
  { value: '13:25:00', label: '01:25 PM' },
  { value: '13:30:00', label: '01:30 PM' },
  { value: '13:35:00', label: '01:35 PM' },
  { value: '13:40:00', label: '01:40 PM' },
  { value: '13:45:00', label: '01:45 PM' },
  { value: '13:50:00', label: '01:50 PM' },
  { value: '13:55:00', label: '01:55 PM' },
  { value: '14:00:00', label: '02:00 PM' },
  { value: '14:05:00', label: '02:05 PM' },
  { value: '14:10:00', label: '02:10 PM' },
  { value: '14:15:00', label: '02:15 PM' },
  { value: '14:20:00', label: '02:20 PM' },
  { value: '14:25:00', label: '02:25 PM' },
  { value: '14:30:00', label: '02:30 PM' },
  { value: '14:35:00', label: '02:35 PM' },
  { value: '14:40:00', label: '02:40 PM' },
  { value: '14:45:00', label: '02:45 PM' },
  { value: '14:50:00', label: '02:50 PM' },
  { value: '14:55:00', label: '02:55 PM' },
  { value: '15:00:00', label: '03:00 PM' },
  { value: '15:05:00', label: '03:05 PM' },
  { value: '15:10:00', label: '03:10 PM' },
  { value: '15:15:00', label: '03:15 PM' },
  { value: '15:20:00', label: '03:20 PM' },
  { value: '15:25:00', label: '03:25 PM' },
  { value: '15:30:00', label: '03:30 PM' },
  { value: '15:35:00', label: '03:35 PM' },
  { value: '15:40:00', label: '03:40 PM' },
  { value: '15:45:00', label: '03:45 PM' },
  { value: '15:50:00', label: '03:50 PM' },
  { value: '15:55:00', label: '03:55 PM' },
  { value: '16:00:00', label: '04:00 PM' },
  { value: '16:05:00', label: '04:05 PM' },
  { value: '16:10:00', label: '04:10 PM' },
  { value: '16:15:00', label: '04:15 PM' },
  { value: '16:20:00', label: '04:20 PM' },
  { value: '16:25:00', label: '04:25 PM' },
  { value: '16:30:00', label: '04:30 PM' },
  { value: '16:35:00', label: '04:35 PM' },
  { value: '16:40:00', label: '04:40 PM' },
  { value: '16:45:00', label: '04:45 PM' },
  { value: '16:50:00', label: '04:50 PM' },
  { value: '16:55:00', label: '04:55 PM' },
  { value: '17:00:00', label: '05:00 PM' },
  { value: '17:05:00', label: '05:05 PM' },
  { value: '17:10:00', label: '05:10 PM' },
  { value: '17:15:00', label: '05:15 PM' },
  { value: '17:20:00', label: '05:20 PM' },
  { value: '17:25:00', label: '05:25 PM' },
  { value: '17:30:00', label: '05:30 PM' },
  { value: '17:35:00', label: '05:35 PM' },
  { value: '17:40:00', label: '05:40 PM' },
  { value: '17:45:00', label: '05:45 PM' },
  { value: '17:50:00', label: '05:50 PM' },
  { value: '17:55:00', label: '05:55 PM' },
  { value: '18:00:00', label: '06:00 PM' },
  { value: '18:05:00', label: '06:05 PM' },
  { value: '18:10:00', label: '06:10 PM' },
  { value: '18:15:00', label: '06:15 PM' },
  { value: '18:20:00', label: '06:20 PM' },
  { value: '18:25:00', label: '06:25 PM' },
  { value: '18:30:00', label: '06:30 PM' },
  { value: '18:35:00', label: '06:35 PM' },
  { value: '18:40:00', label: '06:40 PM' },
  { value: '18:45:00', label: '06:45 PM' },
  { value: '18:50:00', label: '06:50 PM' },
  { value: '18:55:00', label: '06:55 PM' },
  { value: '19:00:00', label: '07:00 PM' },
  { value: '19:05:00', label: '07:05 PM' },
  { value: '19:10:00', label: '07:10 PM' },
  { value: '19:15:00', label: '07:15 PM' },
  { value: '19:20:00', label: '07:20 PM' },
  { value: '19:25:00', label: '07:25 PM' },
  { value: '19:30:00', label: '07:30 PM' },
  { value: '19:35:00', label: '07:35 PM' },
  { value: '19:40:00', label: '07:40 PM' },
  { value: '19:45:00', label: '07:45 PM' },
  { value: '19:50:00', label: '07:50 PM' },
  { value: '19:55:00', label: '07:55 PM' },
  { value: '20:00:00', label: '08:00 PM' },
  { value: '20:05:00', label: '08:05 PM' },
  { value: '20:10:00', label: '08:10 PM' },
  { value: '20:15:00', label: '08:15 PM' },
  { value: '20:20:00', label: '08:20 PM' },
  { value: '20:25:00', label: '08:25 PM' },
  { value: '20:30:00', label: '08:30 PM' },
  { value: '20:35:00', label: '08:35 PM' },
  { value: '20:40:00', label: '08:40 PM' },
  { value: '20:45:00', label: '08:45 PM' },
  { value: '20:50:00', label: '08:50 PM' },
  { value: '20:55:00', label: '08:55 PM' },
  { value: '21:00:00', label: '09:00 PM' },
  { value: '21:05:00', label: '09:05 PM' },
  { value: '21:10:00', label: '09:10 PM' },
  { value: '21:15:00', label: '09:15 PM' },
  { value: '21:20:00', label: '09:20 PM' },
  { value: '21:25:00', label: '09:25 PM' },
  { value: '21:30:00', label: '09:30 PM' },
  { value: '21:35:00', label: '09:35 PM' },
  { value: '21:40:00', label: '09:40 PM' },
  { value: '21:45:00', label: '09:45 PM' },
  { value: '21:50:00', label: '09:50 PM' },
  { value: '21:55:00', label: '09:55 PM' },
  { value: '22:00:00', label: '10:00 PM' },
  { value: '22:05:00', label: '10:05 PM' },
  { value: '22:10:00', label: '10:10 PM' },
  { value: '22:15:00', label: '10:15 PM' },
  { value: '22:20:00', label: '10:20 PM' },
  { value: '22:25:00', label: '10:25 PM' },
  { value: '22:30:00', label: '10:30 PM' },
  { value: '22:35:00', label: '10:35 PM' },
  { value: '22:40:00', label: '10:40 PM' },
  { value: '22:45:00', label: '10:45 PM' },
  { value: '22:50:00', label: '10:50 PM' },
  { value: '22:55:00', label: '10:55 PM' },
  { value: '23:00:00', label: '11:00 PM' },
  { value: '23:05:00', label: '11:05 PM' },
  { value: '23:10:00', label: '11:10 PM' },
  { value: '23:15:00', label: '11:15 PM' },
  { value: '23:20:00', label: '11:20 PM' },
  { value: '23:25:00', label: '11:25 PM' },
  { value: '23:30:00', label: '11:30 PM' },
  { value: '23:35:00', label: '11:35 PM' },
  { value: '23:40:00', label: '11:40 PM' },
  { value: '23:45:00', label: '11:45 PM' },
  { value: '23:50:00', label: '11:50 PM' },
  { value: '23:55:00', label: '11:55 PM' },
];

const LabelText = styled(SemiboldText)`
  font-size: 12px;
  text-align: center;
  margin-bottom: 0.25rem;
  margin-top: 0.625rem;
  color: #7c7c7c;
  display: flex;
  flex-shrink: 0;
  flex-direction: row;
`;


class DoctorSlots extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      saving: false,
      slots: [],
      slotCenters: [],
      doctorPracticeId: null,
      networkCenterId: null,
      doctorPracticeActive: '',
      networkCenterTitle: '',
      networkCenterAddress: '',
      networkCenterLocality: '',
      emergencyNumber: '',
      description: '',
      opdCharges: '',
      latitude: '',
      longitude: '',
      formEditing: false,
      postWorkingHours:[],
      page: 1,
      pageSize: 10,
      totalCenters: 0,
      hasUnsavedChanges: false,
      searchValue: undefined,
      searchOptions: [],
      searching: false,
      selectedCenterId: null,
    };
    this.searchTimer = null;
    console.log({ props });

    this.doctorId = props.doctorId;
  }

  componentDidMount = () => {
    this.fetchSlots();
  };

  componentWillUnmount() {
    if (this.searchTimer) clearTimeout(this.searchTimer);
  }

  fetchSlots = () => {
    const { dispatch } = this.props;
    const { page, pageSize, selectedCenterId } = this.state;
    this.setState({ loading: true });
    Promise.all([
      fetchDoctorSlots(this.doctorId, page, pageSize, selectedCenterId),
      fetchDoctorPracticeCenters(this.doctorId, page, pageSize, selectedCenterId),
    ])
      .then(([res, centersRes]) => {
        const slots = res.data;
        dispatch(setDoctorProfile({ slots }));
        this.setState({
          slots,
          slotCenters: centersRes.practices,
          totalCenters:
            centersRes.totalCenters !== undefined
              ? centersRes.totalCenters
              : (centersRes.practices ? centersRes.practices.length : 0),
          hasUnsavedChanges: false,
        });
      })
      .finally(() => this.setState({ loading: false }));
  };

  onSearchInputChange = (value) => {
    this.setState({ searchValue: value });
    if (this.searchTimer) clearTimeout(this.searchTimer);
    if (!value || !value.trim()) {
      this.setState({ searchOptions: [], searching: false });
      return;
    }
    this.setState({ searching: true });
    this.searchTimer = setTimeout(() => {
      fetchCenters(value.trim())
        .then((res) => {
          const options = (res.result || []).map((ele) => ({
            centerId: ele.centerId,
            title: ele.title,
            locality: ele.locality,
          }));
          this.setState({ searchOptions: options });
        })
        .finally(() => this.setState({ searching: false }));
    }, 400);
  };

  onSearchSelect = (centerId) => {
    const apply = () => {
      this.setState(
        {
          selectedCenterId: centerId,
          page: 1,
          searchValue: undefined,
          searchOptions: [],
        },
        this.fetchSlots
      );
    };
    if (this.state.hasUnsavedChanges) {
      Modal.confirm({
        title: 'Unsaved changes',
        content:
          'You have unsaved changes. Filtering will discard them. Continue?',
        okText: 'Discard and continue',
        cancelText: 'Stay',
        onOk: apply,
      });
      return;
    }
    apply();
  };

  onClearFilter = () => {
    const apply = () => {
      this.setState(
        {
          selectedCenterId: null,
          page: 1,
          searchValue: undefined,
          searchOptions: [],
        },
        this.fetchSlots
      );
    };
    if (this.state.hasUnsavedChanges) {
      Modal.confirm({
        title: 'Unsaved changes',
        content:
          'You have unsaved changes. Clearing the filter will discard them. Continue?',
        okText: 'Discard and continue',
        cancelText: 'Stay',
        onOk: apply,
      });
      return;
    }
    apply();
  };

  goToPage = (nextPage) => {
    if (nextPage === this.state.page) return;
    this.setState({ page: nextPage }, this.fetchSlots);
  };

  onPageChange = (nextPage) => {
    if (this.state.hasUnsavedChanges) {
      Modal.confirm({
        title: 'Unsaved changes',
        content:
          'You have unsaved changes on this page. Switching pages will discard them. Continue?',
        okText: 'Discard and continue',
        cancelText: 'Stay on this page',
        onOk: () => this.goToPage(nextPage),
      });
      return;
    }
    this.goToPage(nextPage);
  };

  cancelEditing = () => {
    this.setState({
      formEditing: false,
      doctorPracticeId: null,
      networkCenterId: null,
      doctorPracticeActive: '',
      networkCenterTitle: '',
      networkCenterAddress: '',
      networkCenterLocality: '',
      emergencyNumber: '',
      description: '',
      opdCharges: '',
      latitude: '',
      longitude: '',
    });
  };

  onFromToDateChange = (date, dateString) => {
    console.log({ date, dateString });
    this.setState({
      fromDate: dateString[0],
      toDate: dateString[1],
    });
  };

  componentDidUpdate(prevProps, prevState) {
    // Check if the slots state has changed
    if (prevState.slots !== this.state.slots) {
      const transformedData = this.transformSlotsToWorkingHours(this.state.slots);
      this.setState({ postWorkingHours: transformedData });
    }
  }

  transformSlotsToWorkingHours(slots) {
    const transformedData = slots.reduce((acc, slot) => {
      const { networkCenterId, centerName, postWorkingHours } = slot;
      if (!acc[networkCenterId]) {
        acc[networkCenterId] = { centerId: networkCenterId, postWorkingHour: postWorkingHours };
      } else if (acc[networkCenterId].postWorkingHour !== postWorkingHours) {
        // Assuming the latest postWorkingHours value should be used if there is a discrepancy
        acc[networkCenterId].postWorkingHour = postWorkingHours;
      }
      return acc;
    }, {});

    return Object.values(transformedData);
  }

  onPracticeActiveChange = e => {
    console.log(`checked = ${e.target.checked}`);
    this.setState({
      doctorPracticeActive: e.target.checked,
    });
    updatePracticeCenterActiveStatus(
      this.doctorId,
      this.state.doctorPracticeId,
      e.target.checked
    )
      .then(res => {
        console.log({ res });
        this.fetchPractice();
      })
      .catch(err => {
        console.log({ err });
      });
  };

  getStartAndEndTimeFromKey(key) {
    const slotTimes = key.match(/^\d+-([\d:]+)-([\d:]+)$/);
    const startTime = moment(slotTimes[1], 'HH:mm:ss');
    const endTime = moment(slotTimes[2], 'HH:mm:ss');
    return [startTime, endTime];
  }

  onDaysChanged = (key, centerName, centerId) => (value, action) => {
    console.log(key, value, action);
    const { slots } = this.state;
    const { doctorId } = this;
    const slotTimes = this.getStartAndEndTimeFromKey(key);
    const updatedTimingsArray = Array.from(slots);
    switch (action.action) {
      case 'pop-value':
      case 'remove-value':
        // Find the exact value and remove it
        this.setState({ saving: true });
        const slotIndex = slots.findIndex(ele => {
          console.log(
            ele.startTime,
            slotTimes[0].format('HH:mm:ss'),
            ele.endTime,
            slotTimes[1].format('HH:mm:ss'),
            ele.networkCenterId,
            centerId,
            ele.dow,
            action.removedValue.value
          );
          return (
            ele.startTime === slotTimes[0].format('HH:mm:ss') &&
            ele.endTime === slotTimes[1].format('HH:mm:ss') &&
            ele.networkCenterId === centerId &&
            ele.dow.toString() === action.removedValue.value
          );
        });
        if (slotIndex === -1) {
          return;
        }
        if (updatedTimingsArray[slotIndex].doctorSlotId) {
          deleteDoctorSlot(
            updatedTimingsArray[slotIndex].doctorSlotId,
            centerId,
            doctorId
          ).finally(() => {
            this.setState({ saving: false });
          });
        } else {
          this.setState({ saving: false });
        }
        updatedTimingsArray.splice(slotIndex, 1);
        this.setState({
          slots: updatedTimingsArray,
          hasUnsavedChanges: true,
        });
        break;
      case 'select-option':
        updatedTimingsArray.push({
          doctorId,
          startTime: slotTimes[0].format('HH:mm:ss'),
          endTime: slotTimes[1].format('HH:mm:ss'),
          dow: Number.parseInt(action.option.value),
          networkCenterId: centerId,
          centerName,
        });
        this.setState({
          slots: updatedTimingsArray,
          hasUnsavedChanges: true,
        });
        break;
      default:
        break;
    }
  };

  onSlotTypeChanged = (key, startTime, centerName, centerId) => (
    value,
    action
  ) => {
    console.log(key, startTime, value, action);
    const { slots } = this.state;
    const slotTimes = this.getStartAndEndTimeFromKey(key);
    switch (action.action) {
      case 'select-option':
        // Find all slots with these start and end time slots and modify them
        const updatedTimingsArray = slots.map(ele => {
          if (
            ele.startTime === startTime &&
            ele.endTime === slotTimes[1].format('HH:mm:ss') &&
            ele.networkCenterId === centerId
          ) {
            return Object.assign({}, ele, {
              slotType: value.value,
            });
          }
          return ele;
        });
        this.setState({ slots: updatedTimingsArray, hasUnsavedChanges: true });
        break;
      default:
        break;
    }
  };

  onStartSlotChanged = (key, oldValue, centerName, centerId) => (
    value,
    action
  ) => {
    console.log(key, oldValue, value, action);
    const { slots } = this.state;
    const slotTimes = this.getStartAndEndTimeFromKey(key);
    switch (action.action) {
      case 'select-option':
        // Find all slots with these start and end time slots and modify them
        const updatedTimingsArray = slots.map(ele => {
          if (
            ele.startTime === oldValue &&
            ele.endTime === slotTimes[1].format('HH:mm:ss') &&
            ele.networkCenterId === centerId
          ) {
            return Object.assign({}, ele, {
              startTime: value.value,
            });
          }
          return ele;
        });
        this.setState({ slots: updatedTimingsArray, hasUnsavedChanges: true });
        break;
      default:
        break;
    }
  };

  onEndSlotChanged = (key, oldValue, centerName, centerId) => (
    value,
    action
  ) => {
    console.log(key, oldValue, value, action);
    const { slots } = this.state;
    const slotTimes = this.getStartAndEndTimeFromKey(key);
    switch (action.action) {
      case 'select-option':
        // Find all slots with these start and end time slots and modify them
        const updatedTimingsArray = slots.map(ele => {
          if (
            ele.startTime === slotTimes[0].format('HH:mm:ss') &&
            ele.endTime === oldValue &&
            ele.networkCenterId === centerId
          ) {
            return Object.assign({}, ele, {
              endTime: value.value,
            });
          }
          return ele;
        });
        this.setState({ slots: updatedTimingsArray, hasUnsavedChanges: true });
        break;
      default:
        break;
    }
  };

  addTimeSlot = (centerId, centerName) => () => {
    const { doctorId } = this;
    const { slots } = this.state;
    const updatedSlots = Array.from(slots);
    // Check if an existing first slot time exists
    let found = false;
    let startTimeSlot = '00:00:00';
    while (!found) {
      if (slots.findIndex(ele => ele.startTime === startTimeSlot) === -1) {
        found = true;
      } else {
        startTimeSlot = moment(startTimeSlot, 'HH:mm:ss')
          .add(5, 'minutes')
          .format('HH:mm:ss');
      }
    }
    updatedSlots.push({
      doctorId,
      startTime: startTimeSlot,
      endTime: moment(startTimeSlot, 'HH:mm:ss')
        .add(5, 'minutes')
        .format('HH:mm:ss'),
      dow: 2,
      networkCenterId: centerId,
      centerName,
    });
    this.setState({
      slots: updatedSlots,
      hasUnsavedChanges: true,
    });
  };

  appointmentTypeHandler = (e, centerId) => {
    console.log(`appointmentTypeHandler: ${e}, ${centerId}`);
    const appointmentType = e.toString();
    const appointmentPayload = { appointmentType, centerId };
    console.log('\nappointment payload', appointmentPayload);

    // API to change appointment type
    updateAppointmentType(appointmentPayload)
      .then((resp) => {
        this.fetchSlots();
        const title = 'Successfully updated appointment type!';
        this.handleModalSuccess(title);
      })
      .catch((err) => {
        console.log(err);
      })
  }
  handleModalSuccess = (title) => {
    const seconds = 5;
    const modal = Modal.success({
      title: title,
    });

    setTimeout(() => {
      modal.destroy();
    }, seconds * 1000);
  }

  handleSameDaySlotsChange = (e, centerId, previousToggleValue) => {
    const body = {
      "showSameDaySlot": e ? 1 : 0,
      "centerId": centerId,
      "doctorId": this.doctorId,
      "previousToggleValue": previousToggleValue
    }
    const cId = body.centerId;
    const dId = body.doctorId;
    console.log(e);
    console.log(`cId ${cId}`);
    console.log(`dId ${dId}`);
    updateShowSameDaySlotsStatus(body)
      .then(() => {
        this.fetchSlots();
        const title = `Successfully updated showSameDaySlots Status!`;
        this.handleModalSuccess(title);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  handleTimeRangeChange = (e, centerId, previousTimeRangeValue) => {
    const body = {
      "leadTime": e,
      "centerId": centerId,
      "doctorId": this.doctorId,
      "previousTimeRangeValue": previousTimeRangeValue
    }
    const cId = body.centerId;
    const dId = body.doctorId;
    console.log(e);
    console.log(`cId ${cId}`);
    console.log(`dId ${dId}`);
    updateTimeRangeStatus(body)
      .then(() => {
        this.fetchSlots();
        const title = `Successfully updated Time Range!`;
        this.handleModalSuccess(title);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };


  onCallToggleHandler = (value, centerId) => {
    const appointmentPayload = { value, centerId };
    console.log('\nappointment payload', appointmentPayload);
    updateOnCallBasis(appointmentPayload)
      .then(resp => {
        this.fetchSlots();
        const title = `Successfully updated on-call status`
        this.handleModalSuccess(title);
      })
      .catch((err) => {
        console.log(err);
      })

  }

  submit = () => {
    const { slots, postWorkingHours } = this.state;
    console.log({ slots }, 'submit2');
    this.setState({ saving: true });
    persistDoctorSlots(this.doctorId, slots, postWorkingHours).finally(() => {
      this.setState({ saving: false, hasUnsavedChanges: false });
      this.fetchSlots();
    });
  };

  handleChange = (e, centerId) => {
    const { value: inputValue } = e.target;
    const reg = /^\d+(\.\d+)?$/;

    if (reg.test(inputValue) || inputValue === '') {
        this.setState(prevState => {
            // Copy the previous state of postWorkingHours
            let updatedPostWorkingHours = [...prevState.postWorkingHours];

            // Find the index of the center in the array
            const centerIndex = updatedPostWorkingHours.findIndex(center => center.centerId === centerId);

            if (centerIndex !== -1) {
                // Center already exists, update the working hour
                updatedPostWorkingHours[centerIndex].postWorkingHour = inputValue;
            } else {
                // Center does not exist, add a new entry
                updatedPostWorkingHours.push({ centerId: centerId, postWorkingHour: inputValue });
            }

            return {
                postWorkingHours: updatedPostWorkingHours,
                hasUnsavedChanges: true,
            };
        });
    }
};

getWorkingHourForCenter(centerId) {
  const { postWorkingHours } = this.state;
  const center = postWorkingHours.find(center => center.centerId === centerId);
  return center ? center.postWorkingHour : '';
}


  render() {
    const {
      loading,
      slotCenters,
      slots,
      saving,
      postWorkingHours,
      page,
      pageSize,
      totalCenters,
      searchValue,
      searchOptions,
      searching,
      selectedCenterId,
    } = this.state;
    const appointmentTypeHandler = this.appointmentTypeHandler;
    const onCallToggleHandler = this.onCallToggleHandler;
    const uniqueCenterTimeSlots = {};
    const slotTypes = {};
    console.log(postWorkingHours,'postWorkingHours');
    slots.forEach(slot => {
      const key = `${slot.networkCenterId}-${slot.startTime}-${slot.endTime}`;
      slotTypes[key] = slot.slotType;
      if (uniqueCenterTimeSlots[key]) {
        uniqueCenterTimeSlots[key].push(slot.dow);
      } else {
        uniqueCenterTimeSlots[key] = [slot.dow];
      }
    });
    const renderCenterSlot = (centerName, centerId) => slotKey => {
      const selectedDaysForTimeSlot = [];
      uniqueCenterTimeSlots[slotKey].forEach(val =>
        selectedDaysForTimeSlot.push(dayOptions[val - 1])
      );
      const slotType = slotTypes[slotKey];
      const startTimeSlots = Array.from(timeSlots);
      const endTimeSlots = Array.from(timeSlots);
      slots.forEach(slot => {
        // Remove the already used startTime from the list of available start time slots
        const startSlotIndex = startTimeSlots.findIndex(
          ele =>
            ele.value === slot.startTime &&
            centerId.toString() === slot.networkCenterId.toString()
        );
        const endSlotIndex = endTimeSlots.findIndex(
          ele =>
            ele.value === slot.endTime &&
            centerId.toString() === slot.networkCenterId.toString()
        );
        if (startSlotIndex !== -1) {
          startTimeSlots.splice(startSlotIndex, 1);
        }
        if (endSlotIndex !== -1) {
          endTimeSlots.splice(endSlotIndex, 1);
        }
      });
      const slotTimes = this.getStartAndEndTimeFromKey(slotKey);
      const startTime = slotTimes[0];
      const endTime = slotTimes[1];
      return (
        <Row key={slotKey}>
          <Col xs={24} md={6}>
            <Select
              value={selectedDaysForTimeSlot}
              options={dayOptions}
              isMulti
              styles={{
                container: provided => ({
                  ...provided,
                  flex: 2,
                  margin: '0 5px',
                }),
              }}
              onChange={this.onDaysChanged(slotKey, centerName, centerId)}
            />
          </Col>
          <Col xs={24} md={6}>
            <Select
              value={{ value: slotType, label: slotType === 'fixed' ? 'Fixed' : 'Walk-in' }}
              options={[{ value: 'fixed', label: 'Fixed' }, { value: 'walk-in', label: 'Walk-in' }]}
              styles={{
                container: provided => ({
                  ...provided,
                  flex: 2,
                  margin: '0 5px',
                }),
              }}
              onChange={this.onSlotTypeChanged(
                slotKey,
                startTime.format('HH:mm:ss'),
                centerName,
                centerId
              )}
            /></Col>
          <Col xs={24} md={6}>
            <Select
              value={{
                value: startTime.format('HH:mm:ss'),
                label: startTime.format('hh:mm A'),
              }}
              options={startTimeSlots}
              filterOption={createFilter({
                matchFrom: 'start',
              })}
              styles={{
                container: provided => ({
                  ...provided,
                  flex: 1,
                  margin: '0 5px',
                }),
              }}
              onChange={this.onStartSlotChanged(
                slotKey,
                startTime.format('HH:mm:ss'),
                centerName,
                centerId
              )}
            />
          </Col>
          <Col xs={24} md={6}>
            <Select
              value={{
                value: endTime.format('HH:mm:ss'),
                label: endTime.format('hh:mm A'),
              }}
              options={endTimeSlots}
              filterOption={createFilter({
                matchFrom: 'start',
              })}
              styles={{
                container: provided => ({
                  ...provided,
                  flex: 1,
                  margin: '0 5px',
                }),
              }}
              onChange={this.onEndSlotChanged(
                slotKey,
                endTime.format('HH:mm:ss'),
                centerName,
                centerId
              )}
              isOptionDisabled={option =>
                moment(option.value, 'HH:mm:ss').isSameOrBefore(startTime)
              }
            />
          </Col>
        </Row>
      );
    };
    const renderCenter = center => {
      let onCallStatus = false;
      if (center.onCall === '1') {
        onCallStatus = true;
      }
      console.log('\nonCallStatus', onCallStatus);
      // console.log('\nrender center', center);
      return (
        <Card style={{ overflow: 'visible' }} key={center.centerId}>
          <Row gutter={[32, 12]}>
            <Col span={24}>
              <Col span={6}>
                <Title level={4} style={{ margin: 0 }}>
                  {center.centerName}
                </Title>
              </Col>
              <Col span={3}></Col>
              <Col span={3}><label>Appointment Type</label></Col>
              <Col span={6}>
                <AntSelect value={center.appointmentType} style={{ width: '100%' }} onChange={function (e) {
                  appointmentTypeHandler(e, center.centerId);
                }}>
                  <Option value="walk_in">Walk In</Option>
                  <Option value="prior_appointment">Prior Appointment</Option>
                </AntSelect>
              </Col>
              <Col span={3}>
                <Checkbox checked={onCallStatus} onChange={function (e) {
                  const checked = e.target.checked;
                  const value = checked ? "1" : "0";
                  onCallToggleHandler(value, center.centerId);
                }}>On Call</Checkbox>
              </Col>
            </Col>
          </Row>
          <Row style={{ margin: "5x" }}>
            <Col span={3} style={{ margin: "10px" }}>
              <label style={{ display: "inline-block", fontWeight: 400, color: "black" }}>Same Day Slots</label>
            </Col>

            <Col span={1} style={{ margin: "10px" }} >
              <Switch
                checked={center.showSameDaySlots}
                onChange={(e) => {
                  this.handleSameDaySlotsChange(e, center.centerId, center.showSameDaySlots);
                }
                }
              />
            </Col>

            <Col span={2} style={{ margin: "10px" }} >
              <AntSelect value={center.showSameDaySlots ? center.leadTime + "Hours" : "Select range"} style={{ width: '100%' }} onChange={(e) => {
                this.handleTimeRangeChange(e, center.centerId, center.leadTime);
              }}
                disabled={!center.showSameDaySlots}>
                <Option value="2">2 Hours</Option>
                <Option value="4">4 Hours</Option>
                <Option value="6">6 Hours</Option>
              </AntSelect>
            </Col>

            <Col span={6} style={{ margin: '12px', marginLeft: '100px' }}>
              <label
                style={{
                  display: 'inline-block',
                  fontWeight: 400,
                  color: 'black',
                }}
              >
                Show Slots Post Working hours
              </label>
            </Col>

            <Col span={2} style={{ margin: '10px' }}>
              <Input
                value={this.getWorkingHourForCenter(center.centerId)}
                onChange={(e)=>this.handleChange(e, center.centerId)}
                placeholder="Input a number"
                maxLength={16}
              />
            </Col>

          </Row>
          {Object.keys(uniqueCenterTimeSlots)
            .filter(ele => ele.startsWith(`${center.centerId}-`))
            .map(renderCenterSlot(center.centerName, center.centerId))}
          <Button
            type="primary"
            size="large"
            shape="circle"
            icon="plus"
            style={{ marginTop: '10px' }}
            onClick={this.addTimeSlot(center.centerId, center.centerName)}
          />
        </Card>
      );
    };
    return (
      <Tabs defaultActiveKey="manage" animated={false}>
        <TabPane tab="Manage Slots" key="manage">
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 16,
            padding: '14px 18px',
            background: '#ffffff',
            border: '1px solid #e7e7e7',
            borderRadius: 6,
            marginBottom: 16,
            boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
            flexWrap: 'wrap',
          }}
        >
          <div style={{ flex: '1 1 320px', minWidth: 240 }}>
            <AntSelect
              showSearch
              allowClear
              value={searchValue}
              placeholder="Search centers by name or ID"
              notFoundContent={searching ? <Spin size="small" /> : null}
              filterOption={false}
              onSearch={this.onSearchInputChange}
              onChange={(val) => {
                if (val === undefined) {
                  this.onClearFilter();
                } else {
                  this.onSearchSelect(val);
                }
              }}
              style={{ width: '100%' }}
              optionLabelProp="label"
            >
              {searchOptions.map((opt) => (
                <Option
                  key={opt.centerId}
                  value={opt.centerId}
                  label={`${opt.title} (#${opt.centerId})`}
                >
                  <div style={{ display: 'flex', flexDirection: 'column', padding: '2px 0' }}>
                    <span style={{ fontWeight: 500, color: '#514f54' }}>
                      {opt.title}{' '}
                      <span style={{ color: '#9b9b9b', fontWeight: 400, fontSize: 12 }}>
                        #{opt.centerId}
                      </span>
                    </span>
                    {opt.locality && (
                      <span style={{ fontSize: 12, color: '#7c7c7c' }}>{opt.locality}</span>
                    )}
                  </div>
                </Option>
              ))}
            </AntSelect>
            {selectedCenterId && (
              <div style={{ marginTop: 8, fontSize: 12, color: '#7c7c7c' }}>
                Filtered to center #{selectedCenterId}.{' '}
                <a onClick={this.onClearFilter} style={{ color: '#7651da' }}>
                  Clear filter
                </a>
              </div>
            )}
          </div>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 10,
              padding: '8px 14px',
              background: '#f6f3ff',
              border: '1px solid #d9c8ff',
              borderRadius: 6,
              minWidth: 140,
            }}
          >
            <div
              style={{
                minWidth: 36,
                height: 36,
                padding: '0 10px',
                borderRadius: 18,
                background: '#7651da',
                color: '#ffffff',
                fontWeight: 600,
                fontSize: 16,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              {loading
                ? '…'
                : selectedCenterId
                ? slotCenters.length
                : totalCenters}
            </div>
            <div style={{ fontSize: 13, fontWeight: 600, color: '#514f54' }}>
              {selectedCenterId ? 'Filtered' : 'Total Centers'}
            </div>
          </div>
        </div>
        <Row gutter={[16, 16]}>
          <Spin spinning={loading || saving}>
            {slotCenters.length > 0 && slotCenters.map(renderCenter)}
            <Col span={24}>
              <Button type="primary" onClick={this.submit}>
                Save
              </Button>
            </Col>
            {!selectedCenterId && totalCenters > pageSize && (
              <Col span={24} style={{ padding: '12px 0', textAlign: 'right' }}>
                <Pagination
                  current={page}
                  pageSize={pageSize}
                  total={totalCenters}
                  showSizeChanger={false}
                  onChange={this.onPageChange}
                />
              </Col>
            )}
          </Spin>
        </Row>
        </TabPane>
        <TabPane tab="Bulk Add Slots" key="bulk">
          <DoctorSlotsBulkAdd
            doctorId={this.doctorId}
            onSuccess={() => this.fetchSlots()}
          />
        </TabPane>
      </Tabs>
    );
  }
}

const mapStateToProps = state => ({
  authToken: state.user.authToken,
});

export default connect(mapStateToProps)(DoctorSlots);
